import React, { Component } from "react";
import { DatePicker } from "/src/component/general/DatePicker";
import { TableHeaderColumn, BootstrapTable } from "react-bootstrap-table";

import EntityDropdown from "../../component/EntityDropdown";
import PointFilter from "../../component/PointFilter";
import Pagination from "./../../component/Pagination";
import { dataTableConfig } from "../../config/config";
import { TAKS_REVIEW, ENTITY_DROPDOWN_SETTINGS } from "../../config/lang";

import { reviewTaskPointName, reviewTaskNework, reviewTaskPriority, reviewMerchandiserNamePhone, reviewTaskSupervisor } from "../../util/formatter";
import { getStore } from "../../util/redux/store";
import { translate } from "../../util/util";
import { getCurrentUser } from "../../util/util";

const me = getStore().getState().me;
class Table extends Component {
  constructor(props) {
    super(props);

    this.state = {
      valid: false,
    };
  }

  onRowClick = row => {
    this.props.openTask(row);
  };

  render() {
    const { data, totalDataSize, count, filter, changeFilter, submit, resetFilter } = this.props;
    const tableOptions = {
      ...dataTableConfig,
      onRowClick: this.onRowClick,
    };
    return (
      <div className="row answers-page">
        <div className="md-filter-panel">
          <div className="md-filter-grid">
            <div className="md-filter-field md-filter-field--dates">
              <span className="md-filter-label">Дата</span>
              <div className="md-filter-dates">
                <DatePicker selected={filter.start ? new Date(filter.start) : null} className="datePicker" onChange={date => changeFilter("start", date)} />
                <span className="md-filter-date-sep">—</span>
                <DatePicker selected={filter.end ? new Date(filter.end) : null} className="datePicker" onChange={date => changeFilter("end", date)} />
              </div>
            </div>
            <div className="md-filter-field">
              <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "city", me.language)}</span>
              <EntityDropdown entity="locality" value={filter.visit__point__locality} onChange={o => changeFilter("visit__point__locality", o)} />
            </div>
            {getCurrentUser() && (
              <div className="md-filter-field">
                <span className="md-filter-label">{translate(TAKS_REVIEW, "supervisor", me.language)}</span>
                <EntityDropdown
                  entity="supervisor"
                  value={filter.visit__point__responsible_supervisor}
                  onChange={o => changeFilter("visit__point__responsible_supervisor", o)}
                />
              </div>
            )}
            <div className="md-filter-field">
              <span className="md-filter-label">{translate(TAKS_REVIEW, "network", me.language)}</span>
              <EntityDropdown entity="network" value={filter.visit__point__network} onChange={o => changeFilter("visit__point__network", o)} />
            </div>
            <div className="md-filter-field">
              <span className="md-filter-label">{translate(ENTITY_DROPDOWN_SETTINGS, "template", me.language)}</span>
              <EntityDropdown entity="template" value={filter.task__template} asynch={true} onChange={o => changeFilter("task__template", o)} />
            </div>
            <div className="md-filter-field">
              <span className="md-filter-label">{translate(TAKS_REVIEW, "merchandiser", me.language)}</span>
              <EntityDropdown entity="merchandiser" value={filter.visit__user} onChange={o => changeFilter("visit__user", o)} />
            </div>
          </div>
          <div className="md-filter-grid md-filter-grid--point">
            <PointFilter value={filter.visit__point} onChange={o => changeFilter("visit__point", o)} moduleFilter={filter.visit__point__network} />
          </div>
          <div className="md-filter-actions">
            <div className="md-filter-actions-left">
              <button className="btn btn-primary" onClick={() => submit()}>
                {translate(TAKS_REVIEW, "apply_btn", me.language)}
              </button>
              <button className="btn btn-outline-primary" onClick={() => resetFilter()}>
                {translate(TAKS_REVIEW, "reset_filters_btn", me.language)}
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-12 answers-table-wrap">
          <BootstrapTable
            data={data}
            version="4"
            hover
            bordered={false}
            pagination={false}
            search={false}
            multiColumnSearch={true}
            options={tableOptions}
            fetchInfo={{ dataTotalSize: totalDataSize }}
            className="themed-main-table-container"
            tableHeaderClass="primary"
            trClassName="answers-row-item">
            <TableHeaderColumn dataField="id" isKey hidden></TableHeaderColumn>
            <TableHeaderColumn dataFormat={reviewTaskPointName}>{translate(TAKS_REVIEW, "point", me.language)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={reviewTaskNework}>{translate(TAKS_REVIEW, "network", me.language)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={reviewTaskPriority}>{translate(TAKS_REVIEW, "priority", me.language)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={reviewMerchandiserNamePhone}>{translate(TAKS_REVIEW, "merchandiser", me.language)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={reviewTaskSupervisor}>{translate(TAKS_REVIEW, "responsible_supervisor", me.language)}</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <Pagination pagination={this.props.pagination} updatePage={this.props.updatePage} />
      </div>
    );
  }
}

export default Table;